import { gql } from '@apollo/client';

const GET_AUTHORIZE_TO_PICK_AVAILABLE_SCAN_IDS = gql`
    query GetAuthorizeToPickAvailableScanIds($CustomerPartyFk: Int) {
        getAuthorizeToPickAvailableScanIds(CustomerPartyFk: $CustomerPartyFk) {
            code
            success
            message
            results {
                Id
                ScanId
                WarehouseIn_JobNumber
                WarehouseOut_JobNumber
                OverpackId_PoPartLocation_Fk
                LabelSeries
                UnitOfMeasure_Fk
                TotalQuantity
                LengthInch
                WidthInch
                HeightInch
                LengthCm
                WidthCm
                HeightCm
                WeightLbs
                WeightKg
                VolumeCbm
                VolumeCft
                Warehouse_Fk
                StorageLocation_Fk
                Is_Overpack
                AuthorizedBy
                AuthorizedDate
                ConfirmedBy
                ConfirmedDate
                PutawayBy
                PutawayDate
                CreatedBy
                CreatedDate
                AttachedPOLineItemToScanId {
                    Id
                    LineNumber
                    PartNumber_Part_Fk
                    Part_Number
                    Part_Description
                    ExpectedQuantity
                    ReceivedQuantity
                    AvailableQuantity
                    AssignedQuantity
                }
                Warehouse {
                    Id
                    Name
                    Code
                }
                StorageLocation {
                    Id
                    Code
                }
                WarehouseIn_Fk
                WarehouseOut_Fk
            }
        }
    }
`;

export default GET_AUTHORIZE_TO_PICK_AVAILABLE_SCAN_IDS;
